module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 10.449083f0.png";